export default __webpack_public_path__ + "static/media/plus.46f975f6.svg";